import React from 'react';
import { SwitchProps, Tooltip } from '@mui/material';
import { Control } from 'react-hook-form/dist/types/form';
import { UseControllerProps } from 'react-hook-form/dist/types/controller';
import { FieldValues } from 'react-hook-form/dist/types/fields';
import { FormSwitch } from '../FormSwitch';
import { Controller } from 'react-hook-form';

interface Props<FormValues extends FieldValues = FieldValues> extends SwitchProps {
  tooltip?: string;
  label?: React.ReactNode;
  dataTestId?: string;
  control: Control<FormValues>;
  name: UseControllerProps<FormValues>['name'];
  extraAction?: (nextValue: boolean) => void;
}

export const SwitchField = <FormValues extends FieldValues = FieldValues>({
  name,
  label,
  tooltip,
  control,
  extraAction,
  dataTestId,
  ...other
}: Props<FormValues>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { ref, onChange, ...field } }) => (
        <Tooltip title={tooltip || ''} arrow disableHoverListener={!tooltip}>
          <FormSwitch
            inputRef={ref}
            label={label}
            checked={field.value}
            dataTestId={dataTestId}
            {...field}
            onChange={(value, checked) => {
              onChange(value);
              extraAction?.(checked);
            }}
            {...other}
          />
        </Tooltip>
      )}
    />
  );
};
